/* eslint no-unused-vars: 0  */
/* global $ */

/* Any custom project animations */

$(document).ready(() => {
  // set up ScrollMagic controller
  const controller = new window.ScrollMagic.Controller();

  // set up ScrollMagic scene
  const scene1 = new window.ScrollMagic.Scene({
    triggerElement: '#trigger',
    triggerHook: 'onLeave',
  })
    .setClassToggle('#pin-area', 'sticky')
    .addTo(controller);

  $('.event-item').each(function() {
    const tl = new window.TimelineMax();
    const event = $(this);

    // tl.from(event, 1, { opacity: 0 }, 'reveal');
    tl.from(event, 0.25, { opacity: 0 });
    tl.to(event, 0.25, { opacity: 0 }, 0.75);

    const scene2 = new window.ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.9,
      duration: '73%',
    })
      .setTween(tl)
      .addTo(controller);
  });
});
